import { format } from "date-fns/format";
import { nb } from "date-fns/locale/nb";

export function formaterDato(dato?: string, dateFnsformat = "Pp") {
  if (typeof dato !== "string") return "Ukjent dato";

  try {
    return format(new Date(dato), dateFnsformat, { locale: nb });
  } catch (e) {
    console.error("Kunne ikke formattere dato:" + dato, e);
    return dato;
  }
}
